<template>
  <div :class="model.background" class="py-8 lg:py-16">
    <div class="container mx-auto flex max-w-screen-lg flex-col justify-between md:flex-row md:pb-[80px]">
      <div class="w-full rounded-xl bg-white p-12 drop-shadow-lg md:w-1/2">
        <div class="mb-4 text-lg font-bold">{{ model.blockLeftTitle }}</div>
        <div v-if="model.blockLeftText" class="specs-block-content leading-7" v-html-safe="model.blockLeftText"></div>
      </div>
      <div
        class="relative mt-8 w-full rounded-xl bg-[color:var(--color-secondary-500)] p-12 text-white drop-shadow-lg md:top-[80px] md:mt-0 md:w-1/2"
      >
        <div class="mb-4 text-lg font-bold">{{ model.blockRightTitle }}</div>
        <div v-if="model.blockRightText" class="specs-block-content leading-7" v-html-safe="model.blockRightText"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  model: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss">
.specs-block-content {
  ul,
  ol {
    list-style: auto;
    list-style-position: inside;
  }
}
</style>
